import { render, staticRenderFns } from "./validation-editor.vue?vue&type=template&id=980e21a8&scoped=true&"
import script from "./validation-editor.vue?vue&type=script&lang=js&"
export * from "./validation-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e21a8",
  null
  
)

export default component.exports